function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#eca657}.cls-2{fill:#656161}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M11.078 3.4H.583a.567.567 0 1 1 0-1.133h1.75V1.7A1.727 1.727 0 0 1 4.082 0h3.5a1.727 1.727 0 0 1 1.747 1.7v.568h1.749a.567.567 0 1 1 0 1.133zm-7-2.268A.576.576 0 0 0 3.5 1.7v.568h4.663V1.7a.575.575 0 0 0-.582-.567z",
  className: "cls-1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Shape_Copy",
  d: "M.513 8a1.153 1.153 0 0 0 1.166 1.07h7.137A1.153 1.153 0 0 0 9.982 8l.518-8H0z",
  className: "cls-2",
  "data-name": "Shape Copy",
  transform: "translate(.68 4.47)"
});

function SvgTrashMeal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trash",
    width: 11.661,
    height: 13.54,
    viewBox: "0 0 11.661 13.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashMeal);
export default __webpack_public_path__ + "static/media/trash-meal.6e45af48.svg";
export { ForwardRef as ReactComponent };